// module.exports = 'M0,0 L12,0 L12,4 L4,4 L4,28 L28,28 L28,20 L32,20 L32,32 L0,32 L0,0 Z M16.844,0 L32,0 L32,15.156 L26.316,9.472 L17.788,18 L14,14.212 L22.528,5.684 L16.844,0 Z'
module.exports = 'M9.844 0 25 0 25 15.156 19.316 9.472 10.788 18 7 14.212 15.528 5.684z'



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Icon/paths/external.js